module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments-clan-landing-sm.1768ceb7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments-clan-landing-sm.png
// module id = 3709
// module chunks = 11